module.exports = __webpack_public_path__ + "img/workers_base.9e2978ab.svg";